"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3596],{

/***/ 9934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ SocialSignOn; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@blueprintjs/core/lib/esm/components/index.js + 77 modules
var components = __webpack_require__(1300);
// EXTERNAL MODULE: ../../node_modules/@blueprintjs/core/lib/esm/common/classes.js
var classes = __webpack_require__(91942);
// EXTERNAL MODULE: ../../packages/hooks/dist/index.js + 24 modules
var dist = __webpack_require__(4495);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/functional/social-sign-on/social-sign-on.tsx





const SocialSignOn = (param)=>{
    let { text , onError , onSuccess  } = param;
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const { analytics , signIn  } = (0,dist/* useAnalytics */.z$)();
    // const auth = useAuthUser();
    const handleSocialSignOn = async (param)=>{
        let { type  } = param;
        setIsLoading(true);
        try {
            var ref;
            const { FacebookAuthProvider , getAuth , signInWithPopup , GoogleAuthProvider , OAuthProvider  } = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 70971));
            let provider;
            switch(type){
                case "google":
                    provider = new GoogleAuthProvider();
                    break;
                case "facebook":
                    provider = new FacebookAuthProvider();
                    provider.addScope("email");
                    break;
                case "apple":
                    provider = new OAuthProvider("apple.com");
                    break;
                default:
                    throw new Error("Unknown provider");
            }
            const result = await signInWithPopup(getAuth(), provider);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            analytics.identify(result.user.uid, {
                ...result.user
            });
            signIn({
                method: type,
                email: (ref = result.user) === null || ref === void 0 ? void 0 : ref.email
            });
        // auth.
        } catch (error) {
            // @ts-ignore
            if (error.code === "auth/account-exists-with-different-credential") {
                onError === null || onError === void 0 ? void 0 : onError("Your account exists, but you signed up with a different method");
            }
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "p-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Spinner */.$j, {
                className: "text-white"
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col justify-start mt-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Button */.zx, {
                        type: "button",
                        onClick: ()=>handleSocialSignOn({
                                type: "google"
                            }),
                        className: classnames_default()(classes.LARGE, "bg-white font-medium mb-2 shadow-none"),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: 20,
                            height: 30,
                            viewBox: "0 0 30 30",
                            fill: "none",
                            className: "my-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    clipPath: "url(#prefix__clip0)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M29.4 15.333a14.633 14.633 0 01-4.467 11.034h-4.85V22.6a6.85 6.85 0 002.984-4.533H15v-5.8h14.133c.175 1.013.264 2.038.267 3.066z",
                                            fill: "#3E82F1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M25 26.367A14.366 14.366 0 0115 30a15 15 0 01-13.333-8.333v-3.884h5A8.95 8.95 0 0015 23.967a9.05 9.05 0 005-1.434l5 3.834z",
                                            fill: "#32A753"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M6.666 12.15a8.933 8.933 0 000 5.7l-5 3.817a15 15 0 010-13.467h5v3.95z",
                                            fill: "#F9BB00"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M25 3.9l-4.3 4.317a8.05 8.05 0 00-5.733-2.25 8.95 8.95 0 00-8.333 6.183L1.667 8.333A15 15 0 0115 0a14.417 14.417 0 0110 3.9z",
                                            fill: "#E74235"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                        id: "prefix__clip0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#fff",
                                            d: "M0 0h29.4v30H0z"
                                        })
                                    })
                                })
                            ]
                        }),
                        children: [
                            text,
                            " Google"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Button */.zx, {
                        type: "button",
                        onClick: ()=>handleSocialSignOn({
                                type: "facebook"
                            }),
                        className: classnames_default()(classes.LARGE, "bg-white font-medium mb-2 shadow-none"),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "20",
                            height: "30",
                            viewBox: "0 0 30 30",
                            fill: "none",
                            className: "my-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M30 15C30 6.71572 23.2843 0 15 0C6.71572 0 0 6.71572 0 15C0 22.4868 5.48525 28.6925 12.6562 29.8178V19.3359H8.84766V15H12.6562V11.6953C12.6562 7.93594 14.8957 5.85938 18.322 5.85938C19.9626 5.85938 21.6797 6.15234 21.6797 6.15234V9.84375H19.7883C17.925 9.84375 17.3438 11.0001 17.3438 12.1875V15H21.5039L20.8389 19.3359H17.3438V29.8178C24.5147 28.6925 30 22.4868 30 15Z",
                                    fill: "#1877F2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M20.8389 19.3359L21.5039 15H17.3438V12.1875C17.3438 11.0013 17.925 9.84375 19.7883 9.84375H21.6797V6.15234C21.6797 6.15234 19.9632 5.85938 18.322 5.85938C14.8957 5.85938 12.6562 7.93594 12.6562 11.6953V15H8.84766V19.3359H12.6562V29.8178C14.2093 30.0607 15.7907 30.0607 17.3438 29.8178V19.3359H20.8389Z",
                                    fill: "white"
                                })
                            ]
                        }),
                        children: [
                            text,
                            " Facebook"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Button */.zx, {
                        type: "button",
                        onClick: ()=>handleSocialSignOn({
                                type: "apple"
                            }),
                        className: classnames_default()(classes.LARGE, "bg-white font-medium shadow-none"),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: 20,
                            height: 30,
                            viewBox: "0 0 26 30",
                            fill: "none",
                            className: "my-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                    clipPath: "url(#prefix__clip0)",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M21.286 15.85c-.014-2.457 1.11-4.312 3.382-5.678-1.272-1.801-3.192-2.793-5.729-2.987-2.401-.187-5.026 1.386-5.986 1.386-1.015 0-3.341-1.319-5.168-1.319C4.011 7.312 0 10.232 0 16.172c0 1.754.325 3.567.974 5.437.866 2.458 3.99 8.485 7.25 8.384 1.705-.04 2.91-1.198 5.128-1.198 2.15 0 3.267 1.198 5.168 1.198 3.287-.047 6.114-5.524 6.94-7.988-4.41-2.056-4.174-6.027-4.174-6.155zM17.458 4.855C19.304 2.685 19.135.71 19.08 0c-1.63.094-3.517 1.098-4.593 2.337-1.183 1.326-1.88 2.967-1.731 4.815 1.765.134 3.375-.764 4.7-2.297z",
                                        fill: "#000"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                        id: "prefix__clip0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#fff",
                                            d: "M0 0h25.5v30H0z"
                                        })
                                    })
                                })
                            ]
                        }),
                        children: [
                            text,
                            " Apple"
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/functional/social-sign-on/index.tsx



/***/ }),

/***/ 81041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* reexport */ AppLayout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./libs/constants/routes.ts
var routes = __webpack_require__(69463);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/components/dist/index.js
var dist = __webpack_require__(76303);
// EXTERNAL MODULE: ../../node_modules/firebase/auth/dist/index.esm.js + 2 modules
var index_esm = __webpack_require__(70971);
// EXTERNAL MODULE: ../../node_modules/next-firebase-auth/build/index.browser.js
var index_browser = __webpack_require__(78868);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./libs/links/links.ts
var links = __webpack_require__(1579);
// EXTERNAL MODULE: ../../node_modules/@blueprintjs/core/lib/esm/components/index.js + 77 modules
var components = __webpack_require__(1300);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/utils/dist/index.js
var utils_dist = __webpack_require__(98727);
;// CONCATENATED MODULE: ./components/ui/page-toast/page-toast.tsx






const PageToast = ()=>{
    const router = (0,next_router.useRouter)();
    const params = new URLSearchParams((0,utils_dist.queryToString)(router.query));
    const [errMessage, setErrMessage] = (0,react.useState)(null);
    const [successMessage, setSuccessMessage] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (router.query["error_msg"]) {
            setErrMessage(String(router.query["error_msg"]));
            params.delete("error_msg");
            router.push((0,links/* withSearchParams */.Q)(router.pathname, params), {}, {
                shallow: true
            });
        }
    }, [
        router.query["error_msg"]
    ]);
    (0,react.useEffect)(()=>{
        if (router.query["success_msg"]) {
            setSuccessMessage(String(router.query["success_msg"]));
            params.delete("success_msg");
            router.push((0,links/* withSearchParams */.Q)(router.pathname, params), {}, {
                shallow: true
            });
        }
    }, [
        router.query["success_msg"]
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Toaster */.x7, {
        children: [
            errMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Toast */.FN, {
                intent: "warning",
                icon: "warning-sign",
                message: errMessage,
                onDismiss: ()=>setErrMessage(null)
            }),
            successMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Toast */.FN, {
                intent: "success",
                icon: "thumbs-up",
                message: successMessage,
                onDismiss: ()=>setSuccessMessage(null)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ui/app-layout/app-layout.tsx










const CookieConsent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8461), __webpack_require__.e(2925)]).then(__webpack_require__.bind(__webpack_require__, 56055)).then((c)=>c.CookieConsent), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(56055)
            ]
    }
});
const AppLayout = (props)=>{
    const authUser = (0,index_browser.useAuthUser)();
    const userIcon = authUser.photoURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: authUser.photoURL,
        alt: "user image",
        width: 20,
        height: 20,
        className: "rounded-md"
    }) : "person";
    var ref;
    const userText = (ref = authUser === null || authUser === void 0 ? void 0 : authUser.displayName) !== null && ref !== void 0 ? ref : authUser === null || authUser === void 0 ? void 0 : authUser.email;
    const menu = (0,react.useMemo)(()=>{
        if (authUser.firebaseUser) {
            return {
                toggleButton: {
                    className: "bg-transparent outline-none shadow-none bg-gray-800 rounded-md",
                    icon: userIcon,
                    text: userText,
                    small: true
                },
                items: [
                    {
                        icon: userIcon,
                        text: userText
                    },
                    {
                        href: routes/* routes.ACCOUNT.ACCOUNT */._j.ACCOUNT.ACCOUNT,
                        text: "Account"
                    },
                    {
                        onClick: ()=>(0,index_esm.signOut)((0,index_esm.getAuth)()),
                        text: "Logout"
                    }
                ]
            };
        }
    }, [
        authUser
    ]);
    const ctas = (0,react.useMemo)(()=>{
        if (!authUser.firebaseUser) {
            return [
                {
                    href: {
                        pathname: routes/* routes.LOGIN */._j.LOGIN
                    },
                    children: "Log In",
                    variant: "secondary",
                    className: "bg-secondary-500 mr-3"
                },
                {
                    href: {
                        pathname: routes/* routes.SIGNUP */._j.SIGNUP
                    },
                    children: "Sign Up",
                    variant: "primary"
                }
            ];
        }
    }, [
        authUser
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(props.className, "min-h-screen flex flex-col"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* NavBar */.l2, {
                logo: {
                    url: "/NuLogo_tag_darkwave_lockup@4x.png",
                    width: 105,
                    height: 30
                },
                ctas: ctas,
                menu: menu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageToast, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent, {}),
            props.children
        ]
    });
};

;// CONCATENATED MODULE: ./components/ui/app-layout/index.tsx



/***/ }),

/***/ 1579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ withSearchParams; }
/* harmony export */ });
const withSearchParams = (route, params)=>"".concat(route, "?").concat(params.toString());


/***/ }),

/***/ 15564:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FR": function() { return /* binding */ be; },
/* harmony export */   "Fq": function() { return /* binding */ l; },
/* harmony export */   "Iv": function() { return /* binding */ t; },
/* harmony export */   "aW": function() { return /* binding */ i; },
/* harmony export */   "k6": function() { return /* binding */ e; }
/* harmony export */ });
/* unused harmony exports chargifyErrorCodes, chargifyErrorsMap, checkoutErrorsMap, discPurchaseErrorCodes, discPurchaseErrorMap, firebaseAuthErrors, firebaseCodeErrors, formCodeErrors, formErrorsMap, genericErrorsMap, pageErrorCodes, pageErrorsMap, shippingErrorCodes, shippingErrorsMap, subscriptionErrorsMap */
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70971);
var d={PAY_PAL:{MISSING:"chargify-001"}};var p=new Map([[d.PAY_PAL.MISSING,{message:"Please Log into your PayPal account using the provided button",html:"<div>Please Log into your PayPal account using the provided button</div>"}]]);var e={CHECKOUT:{COUNTRY:{NOT_SUPPORTED:"checkout-001",CHINA_NOT_SUPPORTED:"checkout-002"},PRODUCT:{NOT_SUPPORTED:"checkout-003"},SHIPPING:{NOT_REQUIRED:"checkout-004"},UNEXPECTED:"checkout-005",DECLINED:"checkout-006",REMAINING_STEPS:"checkout-007",PROMO_CODE_INVALID:"checkout-008",PROMO_CODE_VALID:"checkout-009",ERRORS:"checkout-010",CARD:{NOT_SUPPORTED:"checkout-011"},TERMS_AND_SERVICES:"checkout-012"}};var c=new Map([[e.CHECKOUT.COUNTRY.NOT_SUPPORTED,{message:"The country you have selected is not supported",html:"<div>The country you have selected is not supported</div>"}],[e.CHECKOUT.COUNTRY.CHINA_NOT_SUPPORTED,{message:"We have a partner in China so no orders can be placed there",html:"<div>Please click <a href='http://nucalm.com.cn/'>here</a> to purchase your product directly from our Chinese partner.</div>"}],[e.CHECKOUT.PRODUCT.NOT_SUPPORTED,{message:"The product you have selected is not supported in your country",html:"<div>Sorry, this product is not supported outside of the United States. Please click <a href='https://nucalm.com/pricing?locale=international'>here</a> to view all available international plans</div>"}],[e.CHECKOUT.UNEXPECTED,{message:"There was an issue processing your subscription, please try again. If you continue to encounter an issue please contact us at support@nucalm.com",html:"<div>There was an issue processing your subscription, please try again. If you continue to encounter an issue please contact us at support@nucalm.com</div>"}],[e.CHECKOUT.DECLINED,{message:"Your card has been declined. Please add another payment method and try again",html:"<div>Your card has been declined. Please add another payment method and try again.</div>"}],[e.CHECKOUT.REMAINING_STEPS,{message:"Please press 'Continue' on any remaining steps - ",html:"<div>Please press 'Continue' on any remaining steps - </div>"}],[e.CHECKOUT.PROMO_CODE_INVALID,{message:"Invalid promo code",html:"<div>Invalid promo code</div>"}],[e.CHECKOUT.PROMO_CODE_VALID,{message:"Promo code applied successfully",html:"<div>Promo code applied successfully </div>"}],[e.CHECKOUT.PROMO_CODE_VALID,{message:"Promo code applied successfully",html:"<div>Promo code applied successfully </div>"}],[e.CHECKOUT.ERRORS,{message:"Please correct the errors above before you continue",html:"<div>Please correct the errors above before you continue</div>"}],[e.CHECKOUT.CARD.NOT_SUPPORTED,{message:"This type of card is not supported. Please provide any one of these cards: Visa, Master Card, American Express, Diners Club, JCB, Discover",html:"<div>This type of card is not supported. Please provide any one of these cards: Visa, Master card, American Express, Diners Club International, JCB Card, Discover</div>"}],[e.CHECKOUT.TERMS_AND_SERVICES,{message:"Please agree to the Terms & Services",html:"<div>Please agree to the Terms & Services</div>"}]]);var m={DISC_PURCHASE:{PAYMENT:{INVALID:"disc-purchase-001"}}};var u=new Map([[m.DISC_PURCHASE.PAYMENT.INVALID,{message:"The payment method attached to your subscription is invalid. Please update your payment information",html:"<div>The payment method attached to your subscription is invalid. Please update your payment information</div>"}]]);var o={EMAIL:{INVALID:"firebase-email-001",MISSING:"firebase-email-002",IN_USE:"firebase-email-003"},PASSWORD:{INVALID:"firebase-password-001"},USER:{DISABLED:"firebase-user-001",NOT_FOUND:"firebase-user-002"},ACCOUNT:{TOO_MANY_REQUEST:"firebase-account-001",DIFFERENT_CREDENTIALS:"firebase-account-002"},LOGIN:{FAIL:"firebase-login-001"}},V={"auth/missing-email":o.EMAIL.MISSING,"auth/invalid-email":o.EMAIL.INVALID,"auth/email-already-in-use":o.EMAIL.IN_USE,"auth/user-disabled":o.USER.DISABLED,"auth/user-not-found":o.USER.NOT_FOUND,"auth/invalid-password":o.PASSWORD.INVALID,"auth/too-many-requests":o.ACCOUNT.TOO_MANY_REQUEST,"auth/wrong-password":o.PASSWORD.INVALID,"auth/account-exists-with-different-credential":o.ACCOUNT.DIFFERENT_CREDENTIALS,general:o.LOGIN.FAIL};var l=new Map([[firebase_auth__WEBPACK_IMPORTED_MODULE_0__.AuthErrorCodes.INVALID_EMAIL,{message:"Please provide a valid email address",html:"<div>Please provide a valid email address </div>"}],[firebase_auth__WEBPACK_IMPORTED_MODULE_0__.AuthErrorCodes.EMAIL_EXISTS,{message:"This email is already in use",html:"<div>This email is already in use<div>"}],[firebase_auth__WEBPACK_IMPORTED_MODULE_0__.AuthErrorCodes.INVALID_PASSWORD,{message:"Your email or password is incorrect",html:"<div>Your email or password is incorrect</div>"}],[firebase_auth__WEBPACK_IMPORTED_MODULE_0__.AuthErrorCodes.USER_DISABLED,{message:"Unable to log in. Please contact support for more information",html:"<div>Unable to log in. Please contact support for more information</div>"}],[firebase_auth__WEBPACK_IMPORTED_MODULE_0__.AuthErrorCodes.USER_DELETED,{message:"Could not find a user with that email, Please sign up",html:"<div>Could not find a user with that email, Please sign up</div>"}],[firebase_auth__WEBPACK_IMPORTED_MODULE_0__.AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER,{message:"Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later",html:"<div>Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later</div>"}],[firebase_auth__WEBPACK_IMPORTED_MODULE_0__.AuthErrorCodes.NEED_CONFIRMATION,{message:"Unable to process log in request",html:"<div>Unable to process log in request</div>"}],[firebase_auth__WEBPACK_IMPORTED_MODULE_0__.AuthErrorCodes.NEED_CONFIRMATION,{message:"Your account exists, but you signed up with a different method",html:"<div>Your account exists, but you signed up with a different method</div>"}]]);var s={INPUT:{REQUIRED:"form-input-001",EMAIL:"form-input-002",PHONE:"form-input-003",PASSWORD:"form-input-004",PASSWORD_MATCH:"form-input-005",OPTION:"form-input-006"},VALIDATION:{GREATER_THAN_8:"form-validation-001",INCLUDE_UPPER_CASE_LETTER:"form-validation-002",INCLUDE_ONE_NUMBER:"form-validation-003",INCLUDE_ONE_SPECIAL_CHAR:"form-validation-004"}};var E=new Map([[s.INPUT.REQUIRED,{message:"This field is required",html:"<div>This field is required<div>"}],[s.INPUT.EMAIL,{message:"Please provide a valid email",html:"<div>Please provide a valid email<div>"}],[s.INPUT.PHONE,{message:"Please provide a valid phone number",html:"<div>Please provide a valid phone number<div>"}],[s.INPUT.PASSWORD,{message:"Please ensure your password is valid",html:"<div>Please ensure your password is valid<div>"}],[s.INPUT.PASSWORD_MATCH,{message:"Your passwords do not match",html:"<div>Your passwords do not match<div>"}],[s.VALIDATION.GREATER_THAN_8,{message:"Your password must be at least 8 characters in length or longer",html:"<div>Your password must be at least 8 characters in length or longer<div>"}],[s.VALIDATION.INCLUDE_ONE_NUMBER,{message:"Your password must contain at least one number",html:"<div>Your password must contain at least one number<div>"}],[s.VALIDATION.INCLUDE_UPPER_CASE_LETTER,{message:"Your password must contain at least one capital letter",html:"<div>Your password must contain at least one capital letter<div>"}],[s.VALIDATION.INCLUDE_ONE_SPECIAL_CHAR,{message:"Your password must contain at least one special character (!@#$%)",html:"<div>Your password must contain at least one special character (!@#$%)<div>"}]]);var t={ERROR:{PROCESSING_REQUEST:"generic-001",PAGE_LOADING:"generic-002"}};var h=new Map([[t.ERROR.PROCESSING_REQUEST,{message:"An error has occurred while processing your request. If this issue continues to occur please contact us."}],[t.ERROR.PAGE_LOADING,{message:"An issue has occurred while loading the page. Please contact support if this issue persists."}]]);var f={ERROR:{FORM_ERRORS_REMAINING:"page-001"}};var I=new Map([[f.ERROR.FORM_ERRORS_REMAINING,{message:"Please complete any remaining  fields",html:"<div>Please complete any remaining  field</div>"}]]);var P={ADDRESS:{PO_BOX:"shipping-001"}};var T=new Map([[P.ADDRESS.PO_BOX,{message:"International shipments are only permitted to actual, physical addresses. PO Boxes are not permitted delivery addresses.",html:"<div>International shipments are only permitted to actual, physical addresses. PO Boxes are not permitted delivery addresses.</div>"}]]);var i={CREATE:{DUPLICATE_SUBSCRIPTIONS:"subscriptions-001"},STATUS:{PAST_DUE:"subscriptions-002"}};var g=new Map([[i.CREATE.DUPLICATE_SUBSCRIPTIONS,{message:"You are already subscribed to a plan, if you would like to upgrade please manage your subscription or contact us",html:"<div>You are already subscribed, if you would like to upgrade please manage your subscription or contact us</div>"}],[i.STATUS.PAST_DUE,{message:"Your account is in past due. In order to pause discs you must pay your outstanding balance."}]]);function be(n){let r=new Map;switch(n.split("-")[0]){case"checkout":r=c;break;case"subscriptions":r=g;break;case"firebase":r=l;break;case"page":r=I;break;case"form":r=E;break;case"disc-purchase":r=u;break;case"chargify":r=p;break;case"generic":r=h;break;case"shipping":r=T;break;default:}return r.get(n)}
//# sourceMappingURL=index.js.map

/***/ })

}]);